<template>
  <div style="overflow-y: auto;">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:200vh"
      variant="dark"
      id="loader"
    >
      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12" class="headerF"><HeaderFixed/></b-col>
          <b-col cols="12" class="headerM"><HeaderMobile/></b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-breadcrumb style="background-color: #e9ecef78;">
              <b-breadcrumb-item href="#home">
                <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                  Home
                </router-link>
              </b-breadcrumb-item>
              <b-breadcrumb-item href="#" active>Voluntary Load Declaration Application</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
        </b-row>

        <div>
          <!-- Tabs -->
          <b-tabs card fill>
            <!-- Apply Tab -->
            <b-tab title="Apply for Voluntary Load Declaration Scheme" active>
              <div style="padding-left:30px;">
                <b-row style="padding-top: 0px;">
                  <b-col cols="12" sm="3" md="3" lg="2" style="padding-top: 7px;">
                    <span style="font-weight:600">Consumer Number <span class="text-danger">*</span></span>
                  </b-col>
                  <b-col cols="8" sm="3" md="8" lg="4">
                    <b-form-input
                      type="text"
                      maxlength="12"
                      value=""
                      id="consumerNumber"
                      placeholder="Enter your Consumer Number"
                      autocomplete="off"
                      trim
                      required
                    />
                  </b-col>
                  <b-col col cols="5" sm="5" md="3" lg="2" style="padding-top: 5px;" >
                    <img id="captcha" src="#" alt="captcha">
                    <a href="#" @click="generateCaptcha()" ><b-icon icon="arrow-clockwise" font-scale="1.8" style="padding-top:7px"></b-icon></a>
                  
                  </b-col>
                  <b-col col cols="4" sm="4" md="2" lg="2" style="padding-top: 5px;">
                      <b-form-input type="number" id="result" placeholder="Answer" style="padding-top: 7px;" />
                  </b-col> 
                  <b-col cols="4" sm="3" md="3" lg="1">
                    <b-button @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                      <b-icon icon="arrow-right-short" scale="1.8"></b-icon>
                    </b-button>
                  </b-col>
                </b-row>

                <br>

                <div id="UserDetails" class="userDetails marginRight30px">
                  <b-row>
                    <b-col cols="12">
                      <span class="heading">User Details</span>
                    </b-col>
                  </b-row>

                  <hr/>
                  <br>

                  <b-row>
                    <b-col cols="5" sm="2" md="2" lg="3">
                      <span class="label">Consumer Name :</span>
                    </b-col>
                    <b-col cols="7" sm="4" md="4" lg="3">
                      <span id="consName"></span>
                    </b-col>
                    <b-col cols="5" sm="2" md="2" lg="3" class="marginTop10px">
                      <span class="label">Subdivision :</span>
                    </b-col>
                    <b-col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                      <span id="subDiv"></span>
                      <br>
                    </b-col>
                  </b-row>

                  <br>

                  <b-row>
                    <b-col cols="5" sm="2" md="2" lg="3">
                      <span class="label">Mobile No <span class="text-danger">*</span> :</span>
                    </b-col>
                    <b-col cols="7" sm="4" md="4" lg="3">
                      <b-form-input type="text" id="mobile" placeholder="Enter Mobile No" style="width: 50%;" disabled></b-form-input>
                    </b-col>
                    <b-col cols="5" sm="2" md="2" lg="3" class="marginTop10px">
                      <span class="label">Email Id :</span>
                    </b-col>
                    <b-col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                      <b-form-input type="text" id="email" placeholder="Enter Email ID" disabled></b-form-input>
                    </b-col>
                  </b-row>

                  <br>

                  <b-row>
                    <b-col cols="5" sm="2" md="2" lg="3" class="marginTop10px">
                      <span class="label">Tariff Category :</span>
                    </b-col>
                    <b-col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                      <span id="tariffCat"></span>
                    </b-col>
                  </b-row>

                  <br>

                  <b-row>
                    <b-col cols="5" sm="2" md="2" lg="3" class="marginTop10px">
                      <span class="label">Present Connected Load(kW) :</span>
                    </b-col>
                    <b-col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                      <span id="connectedLoad"></span>
                    </b-col>
                    <b-col cols="5" sm="2" md="2" lg="3" class="marginTop10px">
                      <span class="label">Load Applied for(kW) :</span>
                    </b-col>
                    <b-col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                      <b-form-input
                        type="number"
                        id="appliedLoad"
                        placeholder="Enter Applied Load"
                        @keyup="showWarning()"
                      ></b-form-input>
                      <span class="text-danger" id="warning" style="font-size:0.8rem; display:none;">Warning: Meter change cost may be added</span>
                    </b-col>
                  </b-row>

                  <br>

                  <b-row>
                    <b-col cols="5" sm="2" md="2" lg="3" class="marginTop10px">
                      <span class="label">Outstanding Amount (Rs.) :</span>
                    </b-col>
                    <b-col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                      <span id="outstanding"></span>
                    </b-col>
                    <b-col cols="5" sm="2" md="2" lg="3" class="marginTop10px">
                      <span class="label">Last Recharge Date :</span>
                    </b-col>
                    <b-col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
                      <span id="lastPaymentDate"></span>
                    </b-col>
                  </b-row>

                  <br>

                  <b-row>
                    <b-col cols="12">
                      <b-form-checkbox
                        id="checkbox"
                        v-model="status"
                        name="checkbox"
                        value="accepted"
                        unchecked-value="not_accepted"
                      >
                        <div style="text-align:justify">
                          I, <span class="declaration">{{ consName}} </span> or authorized representative hereby declare that the connected
                          load mentioned above is correct to the best of my knowledge and that I shall abide by the rules and
                          regulations in force for this purpose.
                          <br>
                          I <span class="declaration">{{ consName}} </span> or authorized representative also undertake that electrical
                          installation (including internal wiring etc.) in my premises are adequately maintained and capable to handle
                          the enhanced load as applied for. I will further carry out needful upgradation of the electrical installations
                          (internal wiring etc.) in my premises from time to time to ensure proper safety and avoid any untoward
                          incident.
                          <br>
                          I <span class="declaration">{{ consName}} </span> or authorized representative indemnify APDCL authorities from
                          any proceedings before any forum in the event of any untoward incident/accident in my premises due to
                          inadequate electrical installations (internal wiring etc.) in my premise(s).
                          <br>
                          I <span class="declaration">{{ consName}} </span> or authorized representative shall take the responsibilities of
                          maintenance of the transformer and judicious use of load with diversity factor well within the safety limit of
                          the transformer. (Applicable only for consumers having dedicated transformer of 25 kVA Capacity).
                          <br>
                          I <span class="declaration">{{ consName}} </span> or authorized representative authorize APDCL to charge for
                          the additional load as per applicable tariff from next billing cycle.
                          <br>
                          I <span class="declaration">{{ consName}} </span> or authorized representative have cleared all dues payable
                          to APDCL and no amount is left payable as on date.
                          <br>
                          I <span class="declaration">{{ consName}} </span> or authorized representative also authorize APDCL to take any
                          coercive measure (including legal action, disconnection of supply) against me and any of my other installations
                          if any deviation is found in my aforementioned undertaking in future.
                      </div>
                      </b-form-checkbox>
                    </b-col>
                  </b-row>

                  <br>

                  <b-row>
                    <b-col cols="12" sm="3" md="3" lg="3" offset-md="4" offset-lg="4">
                      Date & Time: <span id="dateTime">test</span>
                    </b-col>
                  </b-row>

                  <br>

                  <b-row>
                    <b-col cols="12" sm="3" md="3" lg="3" offset-md="4" offset-lg="4">
                      <b-button block squared variant="primary" id="button" @click="sendOtp()">Submit</b-button>
                      <br>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-tab>

            <!-- Check Application Status Tab -->
            <b-tab title="Check Application Status">
              <b-row>
                <b-col cols="12" sm="12" md="12" lg="2" style="padding-top: 7px;">
                  <span style="font-weight:600">Consumer Number <span class="text-danger">*</span></span>
                </b-col>
                <b-col cols="8" sm="8" md="8" lg="4">
                  <b-form-input type="text" id="consNo" value="" placeholder="Enter Consumer Number" trim required />
                </b-col>
                <b-col cols="4" sm="3" md="3" lg="1">
                  <b-button @click="checkStatus" block pill variant="primary" size="md" class="go" style="width:100%">
                    <b-icon icon="arrow-right-short" scale="1.8"></b-icon>
                  </b-button>
                </b-col>
              </b-row>

              <div id="statusDetails" class="userDetails">
                <hr>
                <b-row>
                  <b-col cols="12">
                    <div id="applDetails" style="width:92vw; font-size:0.8rem">
                      <span class="heading">Application Details</span>
                      <br><br>
                      <b-table bordered responsive :items="applDetails" :fields="applDetailsFields">
                        <template v-slot:cell(bill)="data">
                          <span v-html="data.value"></span>
                        </template>
                        <template v-slot:cell(paymentLink)="data">
                          <span v-html="data.value"></span>
                        </template>
                      </b-table>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </b-container>

      <br>

      <!-- OTP Modal -->
      <b-modal id="otpModal" centered no-close-on-esc no-close-on-backdrop title="OTP Verification" hide-footer>
        <b-overlay :show="show1" spinner-variant="primary" spinner-large rounded="sm" variant="dark" id="loader">
          Enter the OTP received in your mobile number:
          <b-form-input type="number" id="otp"></b-form-input>
          <br>
          <b-button class="btn" variant="primary" id="success-btn" @click="SubmitApplication()">Verify</b-button>
          &nbsp;
          <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()">Resend OTP</b-button>
        </b-overlay>
      </b-modal>

      <!-- Success Modal -->
      <b-modal id="successModal" centered no-close-on-esc no-close-on-backdrop scrollable hide-footer hide-header :static="true">
        <svg class="modalFont" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" cx="65.1" cy="65.1" r="62.1"/>
          <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" points="100.2,40.2 51.5,88.8 29.8,67.5"/>
        </svg>
        <p class="success">VLD Application Submitted Successfully!
          <br>
          <span style="font-size:1.2rem; color:black">Application No: <span id="applicationNo">test</span></span>
          <br>
          <span style="font-size:0.9rem; color:grey">(Kindly note the application number for future reference)</span>
          <br><br>
          <b-button @click="downloadReceipt()" class="btn btn-outline" variant="primary">Download Receipt</b-button>
          &nbsp;
          <b-button @click="reloadPage()" class="btn btn-outline" variant="success">OK</b-button>
        </p>
      </b-modal>

      <!-- Failure Modal -->
      <b-modal id="failureModal" centered scrollable hide-footer hide-header no-close-on-esc no-close-on-backdrop :static="true">
        <svg class="modalFont" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" cx="65.1" cy="65.1" r="62.1"/>
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
        </svg>
        <span style="color:red" id="errorMsg"></span>
        <br>
        <b-button @click="reloadPage()" class="btn btn-outline" variant="danger">OK</b-button>
      </b-modal>

      <!-- Alert Modal -->
      <b-modal id="model" centered scrollable title="ALERT!" :static="true" hide-footer>
        <span class="data" id="modalMsg"></span>
        <br><br>
        <b-button style="width:8rem" variant="outline-primary" @click="closeModal('model')">OK</b-button>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import axios from 'axios';
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
const numWords = require('num-words');
var CryptoJS = require("crypto-js");
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { enc } from 'crypto-js/core';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

var consNo= "";
var oldMob="";
var email ="";
// var aadhaar = "";
var appliedLoad ="";
var categoryCode = "";
var categoryName = "";
var connectedLoad = "";
var meterReq = "No";
var consName="";
var subDiv = "";
var subDivName = "";
var mobile="";
var outstandingAmt="";
var encAdhar="";
var thColor = '#0288d1';
var applNo="";
var esdNo="";

//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";
export default {
  name: 'ConsReg',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
        value: '',
        show: false,
        show1: false,
        show2 : false,
        consNumber: "",
        status: 'not_accepted',
        consName:'',
        consNo:'',
        applNumber :'',
        connectedLoad : '',
        categoryList : [],
        applDetailsFields: [
          { key: 'applNo', label: 'Application No',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'consNo', label: 'Consumer no',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'consName', label: 'Consumer Name',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'applied_load', label: 'Applied Load',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'category', label: 'Category',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'applStatus', label: 'Application Status',thStyle: {width: '20vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'bill', label: 'Bill View',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
          { key: 'paymentLink', label: 'Payment',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },

        ],
        applDetails : [],
        }
  },
  methods: 
  {
    reloadPage()
    {
      window.location.reload();
      window.scrollTo({ top: 0});
    },
     generateCaptcha()
    {
      axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {
                // console.log("captchaImage:::"+response.data);
                document.getElementById("captcha").src= "data:image/png;base64,"+response.data;})
    },
    showDetails() 
    {
      let consNo = document.getElementById("consumerNumber").value;
      this.consNumber = consNo;

      if (consNo === "" || consNo.length < 12) {
        this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("consNo").focus();
        return;
      }

      document.getElementById("appliedLoad").value = "";
      this.status = "not_accepted";
      document.getElementById("warning").style.display = "none";

      // for captcha
      let result = document.getElementById("result").value;
      if (result === "") {
        this.$bvToast.toast('Enter Captcha !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        return;
      }

      let parent = this;
      this.show = true;

      axios.get(this.$urlCommon+'/api/web/vld/getConsDetails?consNo='+consNo+'&result='+result)
        .then((response) => {
          
          parent.show = false;
          document.getElementById("UserDetails").classList.add("showUserDetails");

          let data = response.data;
          let status = data.message;
          let mobileNum = "";
          let emailID = "";
          let temp1 = "";
          let temp2 = "";
          let lenMail = ";"

          if (status === "00") {
            if (data.connType === "SMART PREPAID" && data.block_STATE === "0" && data.pdc_FLAG === "0") {
              let categoryCode = data.category_CODE;
              this.consNo = data.cons_no;
              this.consName = data.cons_name;
              this.subDiv = consNo.substring(0, 3);
              this.subDivName = data.subDivisionName;
              this.categoryName = data.category_NAME;

              document.getElementById("consName").innerHTML = data.cons_name;
              document.getElementById("subDiv").innerHTML = data.subDivisionName;
              document.getElementById("tariffCat").innerHTML = data.category_NAME;
              document.getElementById("connectedLoad").innerHTML = data.connected_LOAD;

              this.connectedLoad = data.connected_LOAD;
              let outstandingAmt = data.outStanding;

              document.getElementById("outstanding").innerHTML = data.outStanding;
              document.getElementById("lastPaymentDate").innerHTML = data.paymentDate;

              mobileNum = data.mobile_no;
              let mobile = mobileNum;

              if (mobileNum) {
                temp1 = mobileNum.substring(0, 2);
                temp2 = mobileNum.substring(8, 10);
                mobileNum = temp1 + '******' + temp2;
                document.getElementById("mobile").value = mobileNum;
              } else {
                this.$bvToast.toast('Kindly update mobile number before proceeding !', {
                  title: `Alert`,
                  variant: 'danger',
                  solid: true
                });
                document.getElementById("mobile").focus();
                return;
              }

              emailID = data.email;
              if (emailID) {
                lenMail = emailID.length;
                temp1 = emailID.substring(0, 3);
                temp2 = emailID.substring(lenMail - 3, lenMail);
                emailID = temp1 + '**********' + temp2;
                document.getElementById("email").value = emailID;
              } else {
                document.getElementById("email").value = "NA";
              }

              parent.consName = data.cons_name;
              document.getElementById("dateTime").innerHTML = new Date().toLocaleString();
            } else if (data.block_STATE !== "0") {
              parent.$bvModal.show('model');
              document.getElementById("modalMsg").innerHTML = "You are not permitted to increase the load under the VLD scheme due to a blocked connection.";
              document.getElementById("UserDetails").classList.remove("showUserDetails");
            } else if (data.pdc_FLAG !== "0") {
              parent.$bvModal.show('model');
              document.getElementById("modalMsg").innerHTML = "You are not permitted to increase the load under the VLD scheme, as your meter is currently disconnected.";
              document.getElementById("UserDetails").classList.remove("showUserDetails");
            } else{
              parent.$bvModal.show('model');
              document.getElementById("modalMsg").innerHTML = "Sorry, only Smart Prepaid consumers are allowed to increase the load under the VLD scheme!";
              document.getElementById("UserDetails").classList.remove("showUserDetails");
            }
          }
          else if (status == "not_smart_prepaid"){
            if(response.data.connType !== "SMART PREPAID"){
              parent.$bvModal.show('model');
              document.getElementById("modalMsg").innerHTML = "Sorry, only Smart Prepaid consumers are allowed to increase the load under the VLD scheme!";
              document.getElementById("UserDetails").classList.remove("showUserDetails");
            }
            else{
              parent.$bvModal.show('model');
              document.getElementById("modalMsg").innerHTML = "Sorry, Consumer Not Found";
              document.getElementById("UserDetails").classList.remove("showUserDetails");
            }
          }
          else if(status == "captcha_incorrect"){
            parent.$bvToast.toast('Invalid Captcha ! Please try again', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            });
            document.getElementById("UserDetails").classList.remove("showUserDetails");
            document.getElementById("result").value="";
            document.getElementById("result").focus();
            parent.generateCaptcha();
            return; 
          } 
          else{
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Consumer Not Found";
            document.getElementById("UserDetails").classList.remove("showUserDetails");
            return;
          }
        })
        .catch((e) => {
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Sorry, Consumer Not Found";
          document.getElementById("UserDetails").classList.remove("showUserDetails");
          this.show = false;
        });
    },

    showWarning()
    {

      appliedLoad = document.getElementById("appliedLoad").value;
      connectedLoad = this.connectedLoad;
      
      if (parseFloat(appliedLoad) > 30) {
        this.$bvToast.toast('The applied load must not exceed 30 kW !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
        document.getElementById("appliedLoad").focus();
        return;
      }
      else if(parseFloat(appliedLoad)<=parseFloat(connectedLoad)){
        this.$bvToast.toast('Connected load and applied load can not be less than or same !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          });
          document.getElementById("appliedLoad").focus();
          return;
      }
      else if(parseFloat(appliedLoad) >= 5 && parseFloat(connectedLoad) < 5)
      {
        meterReq="Yes";
        document.getElementById("warning").style.display="block";

        // this.$bvModal.show('model');
        // document.getElementById("modalMsg").innerHTML="WARNING : Meter Change Cost may be Added";

      }
      else {
        meterReq="No";
        document.getElementById("warning").style.display="none";
      }

    },
    sendOtp() 
    {
      var parent = this;
      var appliedLoad = document.getElementById("appliedLoad").value;
      var consNo = document.getElementById("consumerNumber").value;
    
      if (parseFloat(appliedLoad) > 30) {
        this.$bvToast.toast('The applied load must not exceed 30 kW !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("appliedLoad").focus();
        return;
      } else if (categoryCode <= "53" || categoryCode == "72" || categoryCode == "75") {

        if (parseInt(outstandingAmt) > 0) {
          this.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML =
            "You have balance amount of <strong>Rs. -" + outstandingAmt + "</strong><br>VLD application is not allowed with outstanding bill amount.<br> Please pay your outstanding bill to apply for VLD.";
          return;
        }

        if (parseInt(appliedLoad) <= parseInt(connectedLoad)) {
          this.$bvToast.toast('Connected load and applied load can not be less than or same !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          });
          document.getElementById("appliedLoad").focus();
          return;
        }

        if (parseInt(appliedLoad) == 0) {
          this.$bvToast.toast('Applied load can not be zero !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          });
          document.getElementById("appliedLoad").focus();
          return;
        }

        if (appliedLoad == "") {
          this.$bvToast.toast('Enter Applied Load !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          });
          document.getElementById("appliedLoad").focus();
          return;
        }

        if (this.status === "not_accepted") {
          this.$bvToast.toast('Please Accept Declaration !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          });
          document.getElementById("checkbox").focus();
          return;
        }

        parent.show = true;
        axios.post(parent.$urlCommon + '/api/otp/sendConsumerOTP?consNo=' + consNo)
          .then((response) => {
            parent.show = false;
            if (response.data.msg == "success") {
              if (response.data.otpGenerated == "Y") {
                parent.$bvToast.toast('OTP Sent Successfully !', {
                  title: `Success`,
                  variant: 'success',
                  solid: true
                });
                parent.$bvModal.show('otpModal');
              } else {
                parent.$bvToast.toast('OTP Generation Failed !', {
                  title: `Failed`,
                  variant: 'danger',
                  solid: true
                });
              }
            }
          });

      } else {
        this.$bvModal.show('model');
        document.getElementById("modalMsg").innerHTML =
          "Consumer belonging to category " + categoryName + "</strong> is not allowed to apply for VLD.";
        return;
      }
    },
    closeModal(modalId)
    {
      this.$bvModal.hide(modalId)
    },
    resendOtp()
    {
      var parent =this;
      var mobile = document.getElementById("mobile").value;
      parent.show1= true;
      // axios.post("https://www.apdcl.org/website/api/reGenerateOtp?mobNo="+mobile).then(function(response) {
      axios.post(this.$urlCommon+"/website/api/otp/sendConsumerOTP?consNo="+consNo+"&type=resend").then(function(response) {

        parent.show1= false;
        if (response.data.msg == "success") {
          parent.$bvToast.toast('OTP Sent Successfully !', {
            title: `Success`,
            variant: 'success',
            solid: true
          });
        }
      else {
          parent.$bvToast.toast('OTP Could not Sent !', {
            title: `danger`,
            variant: 'danger',
            solid: true
          });
        }
      });
    },
    SubmitApplication() 
    {
      var otp = document.getElementById("otp").value;
      var parent = this;
      var consNo = document.getElementById("consumerNumber").value;

      if (otp == "") {
        this.$bvToast.toast('Enter OTP !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        return;
      }

      parent.show1 = true;

      axios.post(this.$urlCommon+"/api/web/vld/save?consNo=" + consNo + "&appliedLoad=" + appliedLoad + "&isMeterReq=" + meterReq + "&otp=" + otp)
        .then(function(response) {
          parent.show1 = false;

          if (response.data.msg == "success") 
          {
            parent.$bvModal.show('successModal');
            document.getElementById("applicationNo").innerHTML = response.data.applNo;
            applNo = response.data.applNo;
          } 
          else if (response.data.msg == "failure") 
          {
            parent.$bvModal.show('failureModal');
            document.getElementById("errorMsg").innerHTML = response.data.errorMsg1;
          }
          else if (response.data.status == "invalid_otp")
          {
            // parent.show1 = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Invalid OTP";
          }
          else if(response.data.status == "failure")
          {
            parent.$bvModal.show('failureModal');
            document.getElementById("errorMsg").innerHTML = response.data.msg;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    checkStatus() 
    {
      var consNo = document.getElementById("consNo").value;
      if (consNo == "" || consNo.length < 12) {
        this.$bvToast.toast('Enter 12 digit Consumer Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        return;
      }

      var temp = [];
      var parent = this;
      this.show = true;

      axios.post(parent.$urlArms + "/RestAPI/getVldStatus?consNo=" + consNo)
        .then((response) => {
          parent.show = false;

          if (response.data.length == 0) {
            document.getElementById("statusDetails").classList.remove("showUserDetails");
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "VLD Application not found for this consumer";
            return;
          }

          document.getElementById("statusDetails").classList.add("showUserDetails");
          var billview = "NA";
          var payment = "NA";

          response.data.forEach(element => {
            if (element.applStatusId == 1005 || element.applStatusId == 1006 || element.applStatusId == 1007) {
              billview = "<a href='" + element.document + "' target='_blank'> View Bill </a>";
            }
            if (element.applStatusId == 1005) {
              payment = "<a href='" + element.paymentLink + "' target='_blank'> Payment Link </a>";
            }
            if (element.applStatusId == 1006 || element.applStatusId == 1007) {
              payment = "<a href='" + element.paymentLink + "' target='_blank'> Payment Receipt </a>";
            }

            var obj = {
              "applNo": element.applNo,
              "consNo": element.consNo,
              "consName": element.consName,
              "applied_load": element.connected_load,
              "category": element.category_code_name,
              "applStatus": element.applStatus,
              "bill": billview,
              "paymentLink": payment
            };
            temp.push(obj);
          });

          parent.applDetails = temp;
        });
    },
    downloadReceipt() 
    {
        esdNo = this.consNo;
        var digits = esdNo.toString().split('');
        var realDigits = digits.map(Number);
        var esd1 = realDigits[0];
        var esd2 = realDigits[1];
        var esd3 = realDigits[2];
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = dd + '/' + mm + '/' + yyyy;
        var docDefinition = {
        pageSize: 'A5',
        pageOrientation: 'portrait',
        content: [
          // { image: '../assets/apdcl_logo.png',  width: 150,  height: 150,},
          { text: 'ACKNOWLEDGEMENT RECEIPT', style: 'header' },
          // { text: 'AMICABLE ONE-TIME SETTLEMENT SCHEME', style: 'header' },
          { text: 'Voluntary Load Declaration Scheme, APDCL', style: 'subheader' },
          { text: 'Reg. No: VLD/2025/'+esd1+esd2+esd3+'/'+applNo, style: 'esdNo' },
          { text: 'Application No: '+applNo, style: 'applNo' },
          { text: '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -' },

          { text: 'Application Details:', style: 'heading' },
          { text: ['Consumer No: ', {text: this.consNo , style: 'boldText'},], style: 'normalText' },
          {	text: ['Name of the Consumer: ',	{text:this.consName , style: 'boldText'}, ],style: 'normalText'},
          { text: ['Category name: ', {text: this.categoryName , style: 'boldText'},], style: 'normalText' },
          { text: ['Subdivision: ', {text: this.subDivName, style: 'boldText'},], style: 'normalText' },
          { text: ['Connected Load: ', {text: this.connectedLoad +" KW", style: 'boldText'},], style: 'normalText' },
          { text: ['Applied Load: ', {text: appliedLoad+" KW", style: 'boldText'},], style: 'normalText' },
          { text: '\nNote: Execution of the same is subject to compliance of all applicable terms and conditions and need based physical verification of the consumer installation to the satisfaction of the authority.', style: 'normalText' },
          { text: ['\nDate: '+today,{text: '\t\t\t\t\t\t\t\t\t\t\t\t\tAuthorized signatory', style: 'boldText'}], style: 'normalText'},
          { text: '\n * * This is a system generated statement and no signature is required * * ', style: 'footerText'},
              ],
              styles: {
                  header: {
                  fontSize: 15,
                  bold: true,
                  alignment: 'center',
                  margin: [0, 0, 0, 5]
              },
            subheader: {
                fontSize: 15,
                alignment: 'center',
                bold: true,
                margin: [0, 10, 0, 5]
            },
            applNo: {
                fontSize: 13,
                alignment: 'center',
                color: '#0277bd',
                margin: [0, 10, 0, 5]
            },
            esdNo: {
                fontSize: 10,
                alignment: 'center',
                fontWeight: 'bold',
                // color: '#0277bd',
                margin: [0, 10, 0, 5]
            },
            heading: {
                fontSize: 12,
                alignment: 'left',
                bold: true,
                margin: [0, 10, 0, 5]
            },
            normalText: {
                fontSize: 10,
                alignment: 'left',
                margin: [0, 10, 0, 5],
                width:10
            },
            boldText: {
                fontSize: 11,
                alignment: 'left',
                bold:true,
                margin: [0, 10, 0, 5]
            },
            bottomText: {
                fontSize: 10,
                fontWeight: 600,
                alignment: 'left',
                margin: [0, 10, 0, 5]
            },
            footerText: {
                fontSize: 8,
                alignment: 'center',
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 5, 0],
                alignment: 'left',
                fontSize: 10,
            }
        },

      };

      pdfMake.createPdf(docDefinition).download("VLD_Receipt_" +consNo+ ".pdf");
      setTimeout(function(){ window.location.reload(); }, 2000);

    }
  },
  mounted()
  {
    axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {
               
      document.getElementById("captcha").src= "data:image/png;base64,"+response.data;

    })
  },

}
</script>

<style scoped="true">
.label{
font-weight: 600;
}
.data{
  font-weight: 500;
  color: #bf360c;
  font-size: 1.1rem;
}
.declaration
{
  color:#263238;
  font-weight:600;
}
.userDetails
{
  /* visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear; */
  display:none;
}
.showUserDetails
{
 /* visibility: visible;
 opacity: 1; */
 display:block;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.modalFont{
  width: 100px;
  display: block;
  margin: 40px auto 0;
}

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}
.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}
.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}

p {
  text-align: center;
  margin: 20px 0 60px;
  font-size: 1.25em;
}
p.success {
  color: #73AF55;
}
p.error {
  color: #D06079;
}
.hideDiv
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;

    padding: 0rem;
}
.showDiv
{
 visibility: visible;
 opacity: 1;
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }
  @media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .marginRight30px{
      margin-right: 30px !important;
    }
  }
  @media (max-width: 576px) {
    .marginTop10px{
      margin-top: 10px !important;
    }
  }

</style>
